import { Table } from "reactstrap";
import React from 'react';
import CurrencyFormatter from 'Component/Common/Formatter/CurrencyFormatter';

import 'moment/locale/id';

const OrderContent = ({ item }) => {
    
    return (
        <div className="table-responsive invoice-table" id="table">
            <Table className="table-bordered table-striped">
                <thead>
                    <tr>
                        <th>Nama Perawatan</th>
                        <th>Harga</th>
                        <th>Subtotal</th>
                        <th>Diskon</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                {item.treatment && item.treatment.length > 0 ? (
                    <tr>
                        <td>
                            {item.treatment.map((treatment) => (
                                <span className="d-block" key={treatment.id}>
                                    {treatment.name}
                                </span>
                            ))}
                        </td>
                        <td>
                            {item.treatment.map((treatment) => (
                                <div
                                    key={treatment.id}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                    }}
                                >
                                    <span
                                        style={{
                                            textDecoration: 'line-through',
                                            color: 'red',
                                        }}
                                    >
                                        <CurrencyFormatter amount={treatment.gimmick_price} />
                                    </span>
                                    <CurrencyFormatter amount={treatment.price} />
                                </div>
                            ))}
                        </td>
                        <td><CurrencyFormatter amount={item.subtotal} /></td>
                        <td>
                            <CurrencyFormatter amount={item.discount} />
                            {item.voucher?.code && (
                                <span className="d-block text-success" style={{ fontSize: '12px' }}>
                                    ({item.voucher?.code})
                                </span>
                            )}
                        </td>
                        <td><CurrencyFormatter amount={item.total} /></td>
                    </tr>
                ) : (
                    <tr>
                        <td colSpan="8" className="text-center">
                            Tidak ada data
                        </td>
                    </tr>
                )}
                </tbody>
            </Table>
        </div>
    );
};

export default OrderContent;
